@if (currentOrder && render()) {
  <div class="content">
    <h3>OBS! Hantera pågående order</h3>
    <mat-accordion>
      <mat-expansion-panel expanded="true" class="simple">
        <mat-expansion-panel-header>
          <mat-panel-title class="title"><strong>Order #{{currentOrder.orderId}}</strong></mat-panel-title>
        </mat-expansion-panel-header>
        <ul>
          @for (item of currentOrder.orderItems; track item) {
            <li>
              @if (item.orderItemType === 'FEATURE') {
                <p>{{item.feature?.name}}</p>
              }
              @if (item.orderItemType === 'RESOURCE') {
                <p>
                  <mat-icon>directions_car</mat-icon>
                  <!-- Can add (click)="editBooking(item.booking!)", but needs to be tested thoroughly -->
                  <a>{{item.booking?.registrationNumber}}</a>
                </p>
              }
              @if (item.orderItemType === 'PREPAIDTICKET') {
                <p>{{item.prepaidTicket?.name}} (Abonnemang)</p>
              }
              <div class="amount">
                <p>{{item.amount}} kr</p>
                <button class="removeButton" mat-icon-button (click)="removeOrderItem(item)"><mat-icon>clear</mat-icon>
              </button>
            </div>
          </li>
        }
        <li class="total"><span>Total: </span><span>{{currentOrder.totalAmount}} kr</span></li>
      </ul>
    </mat-expansion-panel>
  </mat-accordion>
  <div class="buttons">
    <button class="button success slim handleButton" (click)="removeOrder()">Avbryt</button>
    <button class="{{'button success slim handleButton' + (finishOrderLoading ? ' loading' : '')}}"
      [disabled]="finishOrderLoading" (click)="finishOrder()">{{isDriverMode ? "Slutför" :
      "Hantera betalning"}}
      @if (finishOrderLoading) {
        <mat-spinner diameter="20" color="accent"></mat-spinner>
      }
    </button>
  </div>
</div>
}